
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-roi/assessment",
      function () {
        return require("private-next-pages/ai-roi/assessment.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-roi/assessment"])
      });
    }
  